<template>
  <div class="series-Add">
    <el-form ref="form" :model="form" :rules="rules" label-width="125px">
      <el-form-item label="名称（中文）：" class="wd" prop="seriesName">
        <el-input v-model="form.seriesName"></el-input>
      </el-form-item>
      <el-form-item label="名称（英文）：" class="wd" prop="seriesEnglishName">
        <el-input v-model="form.seriesEnglishName"></el-input>
      </el-form-item>
      <el-form-item label="排序：" class="wd" prop="seriesSort">
        <el-input v-model="form.seriesSort"></el-input>
      </el-form-item>
      <el-form-item label="品牌分类：" prop="brandId">
        <el-select v-model="form.brandId" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.brandName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="系列介绍：" prop="seriesDetail">
        <editor
          :editContent="form.seriesDetail"
          @getValue="getEditorContent"
        />
      </el-form-item>
      <el-form-item label="图片：" class="uploadImg" prop="seriesUrl">
        <upload
          :url="form.seriesUrl"
          @successUpload="handleSuccessUpload"
          prompt="上传封面图片：大小不超过2M，支持Jpeg、Jpg、Png格式，建议上传690*300尺寸。"
        />
      </el-form-item>
      <el-form-item class="submit">
        <el-button type="primary" :loading="loading" @click="onSubmit('form')">保存</el-button>
        <el-button @click="$router.push({ name:'SeriesList' })">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { addSeries, getAllBrandList } from '@/api/series';
import Upload from '@/components/Upload/index.vue';
import Editor from '@/components/Editor';
import { validCurrency } from '@/utils/validate';

export default {
  name: 'SeriesAdd',
  data() {
    const validNumber = (rule, value, callback) => {
      if (validCurrency(value)) {
        callback();
      } else {
        callback(new Error('请输入正确数字值!'));
      }
    };
    return {
      form: {
        seriesName: '',
        seriesEnglishName: '',
        brandId: '',
        seriesDetail: '',
        seriesUrl: '',
        seriesSort: '',
      },
      options: [],
      rules: {
        seriesName: [
          { required: true, message: '请输入中文名称', trigger: 'blur' },
        ],
        seriesEnglishName: [
          { required: true, message: '请输入英文名称', trigger: 'blur' },
        ],
        brandId: [
          { required: true, message: '请选择品牌分类', trigger: 'blur' },
        ],
        seriesSort: [
          { required: true, message: '排序不能为空', trigger: 'blur' },
          { validator: validNumber, trigger: 'blur' },
        ],
      },
      loading: false,
    };
  },
  components: {
    Upload,
    Editor,
  },
  mounted() {
    this.getAllBrandList();
  },
  methods: {
    // 获取品牌分类
    getAllBrandList() {
      getAllBrandList().then((res) => {
        if (res.success) {
          this.options = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    addSeries() {
      this.loading = true;
      addSeries(this.form).then((res) => {
        if (res.success) {
          this.loading = true;
          this.$message.success('系列添加成功');
          this.$router.push({ name: 'Series' });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.form.seriesDetail) {
            this.$message.warning('系列介绍不能为空');
            return false;
          }
          if (!this.form.seriesUrl) {
            this.$message.warning('请上传图片');
            return false;
          }
          this.addSeries();
          return true;
        }
        return false;
      });
    },
    getEditorContent(value) {
      this.form.seriesDetail = value;
    },
    handleSuccessUpload(url) {
      this.form.seriesUrl = url;
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/css/mixins'
.series-Add
  .el-form
    width 910px
    margin 0 auto
    .uploadImg
      flex-row()
      >>>.el-form-item__content
        margin-left 0 !important
    .submit
      text-align center
    .wd
      >>>.el-input__inner
        width 500px !important
</style>
